import React from 'react';
import { SiteHeader } from '../components/SiteHeader';
import { Hero } from '../components/Hero';
import { BranchBar } from '../components/BranchBar';
import { TrustBar } from '../components/TrustBar';
import { LovedOneStrip } from '../components/LovedOneStrip';
import { Frustrations } from '../components/Frustrations';
import { FamilySection } from '../components/FamilySection';
import { HowItWorks } from '../components/HowItWorks';
import { WhyUs } from '../components/WhyUs';
import { FounderNote } from '../components/FounderNote';
import { Testimonials } from '../components/Testimonials';
import { WaysWeHelp } from '../components/WaysWeHelp';
import { FaqPreview } from '../components/FaqPreview';
import { FreeCallBox } from '../components/FreeCallBox';
import { FinalCta } from '../components/FinalCta';
import { SectionDivider } from '../components/SectionDivider';
import { SiteFooter } from '../components/SiteFooter';
import { MobileBookingBar } from '../components/MobileBookingBar';
export function Home() {
  return <div className="w-full bg-paper font-sans" data-id="element-270" data-mp="30vgmwl2fkxqj">
      <a href="#main" className="sr-only z-[60] rounded-sm bg-gold px-4 py-3 font-semibold text-navy focus:not-sr-only focus:fixed focus:left-4 focus:top-4" data-id="element-271" data-mp="2vxow5udivhnx">
        Skip to content
      </a>
      <SiteHeader data-id="element-272" data-mp="2mxa5sglpbcdk" />
      <main id="main" data-id="element-273" data-mp="2mxs4djvu62on">
        <Hero data-id="element-274" data-mp="2mwgxhb73getb" />
        <BranchBar data-id="element-275" data-mp="2mz34n9q2osb0" />
        <TrustBar data-id="element-276" data-mp="2hxx9l58xwsyb" />
        <LovedOneStrip data-id="element-277" data-mp="2hyffyupbgnjy" />
        <Frustrations data-id="element-278" data-mp="2hyyv63nl0xua" />
        <SectionDivider tone="light" data-id="element-279" data-mp="2hz8fbaly4as2" />
        <FamilySection data-id="element-280" data-mp="2d7gvrk17j5bf" />
        <SectionDivider tone="dark" data-id="element-281" data-mp="2d65txprbo7my" />
        <HowItWorks data-id="element-282" data-mp="2d5vyvnrf7aae" />
        <SectionDivider tone="light" data-id="element-283" data-mp="2883zy9scynwp" />
        <WhyUs data-id="element-284" data-mp="2895o9fydx6wd" />
        <SectionDivider tone="dark" data-id="element-285" data-mp="288ni9rlx7eb9" />
        <FounderNote data-id="element-286" data-mp="285rngc5dd5r1" />
        <SectionDivider tone="dark" data-id="element-287" data-mp="239j9v36tlklz" />
        <Testimonials data-id="element-288" data-mp="23alz76ohvezs" />
        <SectionDivider tone="light" data-id="element-289" data-mp="236y7md2m12np" />
        <WaysWeHelp data-id="element-290" data-mp="1z7xoetg7zy06" />
        <SectionDivider tone="dark" data-id="element-291" data-mp="1z64gzbxs99r4" />
        <FaqPreview data-id="element-292" data-mp="1z9in8v9ki33u" />
        <SectionDivider tone="light" data-id="element-293" data-mp="1u8l4ohknb71t" />
        <FreeCallBox data-id="element-294" data-mp="1u9nuem68f3g5" />
        <FinalCta data-id="element-295" data-mp="1u94knsqqjld7" />
      </main>
      <SiteFooter data-id="element-296" data-mp="1kkqqbobu2uip" />
      <MobileBookingBar data-id="element-297" data-mp="1kkh7qlt4bpn1" />
    </div>;
}